// src/redux/thunks/loginThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/api"; // centralized Axios instance

// src/redux/thunks/sendOtpThunk.js
// import { createAsyncThunk } from '@reduxjs/toolkit';
// import api from '../../utils/api';

export const loginWithOtp = createAsyncThunk(
  "auth/sendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/web/auth/send-login-otp", payload);
      if (res.status === 200) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      console.error("OTP error:", err.message, err.response?.data);
      return rejectWithValue(
        err.response?.data || { message: err.message || "OTP send failed" }
      );
    }
  }
);

export const verifyLoginOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/web/auth/verify-login-otp", payload);
      if (res.status === 200 || res.status === 201) {
        localStorage.setItem("token", JSON.stringify(res.data.token));
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "OTP verification failed" }
      );
    }
  }
);

export const sendRegistrationOtpThunk = createAsyncThunk(
  "auth/sendRegistrationOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post(
        "/api/web/auth/send-registration-otp",
        payload
      );
      if (res.status === 200) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      alert(err.response?.data.error);
      console.error(
        "Registration OTP error:",
        err.message,
        err.response?.data.error
      );
      return rejectWithValue(
        err.response?.data || { message: err.message || "OTP send failed" }
      );
    }
  }
);

export const verifyRegistrationThunk = createAsyncThunk(
  "auth/verifyRegistration",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/web/auth/register", payload);

      if (res.status === 201 || res.status === 200) {
        localStorage.setItem("token", JSON.stringify(res.data.token));
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      console.error(
        "Registration verification error:",
        err.message,
        err.response?.data
      );

      // Always return plain JSON-safe error data
      return rejectWithValue({
        message:
          err?.response?.data?.message ||
          err.message ||
          "Verification failed. Please try again.",
      });
    }
  }
);
export const loginWithPasswordThunk = createAsyncThunk(
  "auth/login",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/web/auth/login-password", payload);
      if (res.status === 200 || res.status === 201) {
        localStorage.setItem("token", JSON.stringify(res.data.token));
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message || "Login failed" }
      );
    }
  }
);

export const getDashboardDataThunk = createAsyncThunk(
  "dashboard/getData",
  async (_, { rejectWithValue }) => {
    console.log("Fetching dashboard data...");
    try {
      const res = await api.get("/api/web/dashboard/patients");
      if (res.status === 200) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to fetch dashboard data",
        }
      );
    }
  }
);

function normalizePendingRequestsPayload(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.pendingRequests)) return raw.pendingRequests;
  if (Array.isArray(raw.requests)) return raw.requests;
  if (Array.isArray(raw.items)) return raw.items;
  if (Array.isArray(raw.checkinNotifications)) return raw.checkinNotifications;
  if (Array.isArray(raw.notifications)) return raw.notifications;
  if (raw.data && typeof raw.data === "object") {
    const d = raw.data;
    if (Array.isArray(d.pendingRequests)) return d.pendingRequests;
    if (Array.isArray(d.requests)) return d.requests;
    if (Array.isArray(d.items)) return d.items;
    if (Array.isArray(d.checkinNotifications)) return d.checkinNotifications;
    if (Array.isArray(d.notifications)) return d.notifications;
  }
  return [];
}

export const getPendingRequestsThunk = createAsyncThunk(
  "dashboard/pendingRequests",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/web/dashboard/pending-requests");
      if (res.status === 200) {
        const items = normalizePendingRequestsPayload(res.data);
        return { success: true, data: items };
      }
      return { success: false, data: [], message: res.data?.message };
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to fetch pending requests",
        }
      );
    }
  }
);

export const getCheckinNotificationsThunk = createAsyncThunk(
  "dashboard/checkinNotifications",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/web/dashboard/checkin-notifications");
      if (res.status === 200) {
        const items = normalizePendingRequestsPayload(res.data);
        return { success: true, data: items };
      }
      return { success: false, data: [], message: res.data?.message };
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to fetch check-in notifications",
        }
      );
    }
  }
);

export const respondToRequestThunk = createAsyncThunk(
  "dashboard/respondRequest",
  async ({ requestId, status }, { rejectWithValue }) => {
    try {
      const res = await api.put("/api/web/dashboard/respond-request", {
        requestId,
        status,
      });
      if (res.status === 200 || res.status === 201) {
        return { success: true, data: res.data, requestId };
      }
      return rejectWithValue(
        res.data?.message
          ? { message: res.data.message }
          : { message: "Request failed" }
      );
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to respond to request",
        }
      );
    }
  }
);

export const addPatientThunk = createAsyncThunk(
  "patients/add",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/web/dashboard/add-patient", payload);
      if (res.status === 200 || res.status === 201) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to add patient",
        }
      );
    }
  }
);

// Correct a patient's self-reported smoking status. Validated server-side to three clinical
// states and written back into the onboarding vocabulary, so the app, the dashboard and the
// alert engine all keep reading one value.
export const updatePatientSmokingThunk = createAsyncThunk(
  "doctor/updatePatientSmoking",
  async ({ patientId, status }, { rejectWithValue }) => {
    try {
      const res = await api.patch(`/api/web/dashboard/patient/${patientId}/smoking`, { status });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to update smoking status" });
    }
  }
);

export const getPatientRecordThunk = createAsyncThunk(
  "patients/getAll",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/web/dashboard/patient/${id}`);
      if (res.status === 200) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to fetch patients",
        }
      );
    }
  }
);

export const getProfileData = createAsyncThunk(
  "doctor/getAll",

  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/web/dashboard/profile");
      if (res.status === 200) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to fetch patients",
        }
      );
    }
  }
);

export const updateProfile = createAsyncThunk(
  "updateProfile",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await api.put(
        "/api/web/dashboard/profile/update",
        formData
      );
      if (res.status === 200) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to update profile",
        }
      );
    }
  }
);

export const askconsultent = createAsyncThunk(
  "askconsultent",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post(
        "/api/web/dashboard/doctor/request-checkin",
        payload
      );
      if (res.status === 200) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      alert(err.response?.data.error);
      console.error("consultent:", err.message, err.response?.data.error);
      return rejectWithValue(
        err.response?.data || { message: err.message || "consultent failed" }
      );
    }
  }
);

export const getConsultentList = createAsyncThunk(
  "consultent/getAll",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `/api/web/dashboard/patient/${id}/vitals-history`
      );
      if (res.status === 200) {
        return { success: true, data: res.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      alert(err.response?.data.error);
      console.error("consultent:", err.message, err.response?.data.error);
      return rejectWithValue(
        err.response?.data || {
          message: err.message || "Failed to fetch consultent list",
        }
      );
    }
  }
);

export const getPatientNotes = createAsyncThunk(
  "patient/getNotes",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/web/dashboard/patient/${id}/notes`);
      if (res.status === 200) {
        return { success: true, data: res.data.data };
      } else {
        return { success: false, data: res.data };
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message || "Failed to fetch notes" }
      );
    }
  }
);

/* ── CuoreMD notification inbox (spec D-series) ──────────────────────────────────────────────
 * Backed by /api/web/notifications, which is the DURABLE half of the doctor channel: the
 * notification:new socket event only reaches a console that is open, so anything raised while
 * the doctor was logged out exists only as a row these endpoints return. The list must always be
 * fully reconstructible from here without any socket.
 * ------------------------------------------------------------------------------------------ */
export const getDoctorNotificationsThunk = createAsyncThunk(
  "notifications/list",
  async ({ page = 1, limit = 20 } = {}, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/web/notifications?page=${page}&limit=${limit}`);
      if (res.status === 200) return res.data;
      return rejectWithValue({ message: res.data?.message || "Could not load notifications" });
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message || "Could not load notifications" }
      );
    }
  }
);

export const markDoctorNotificationReadThunk = createAsyncThunk(
  "notifications/markRead",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.put(`/api/web/notifications/${id}/read`);
      if (res.status === 200) return { id };
      return rejectWithValue({ message: res.data?.message || "Could not mark as read" });
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message || "Could not mark as read" }
      );
    }
  }
);

export const markAllDoctorNotificationsReadThunk = createAsyncThunk(
  "notifications/markAllRead",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.put("/api/web/notifications/read-all");
      if (res.status === 200) return true;
      return rejectWithValue({ message: res.data?.message || "Could not mark all as read" });
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message || "Could not mark all as read" }
      );
    }
  }
);

/* "Delete all" — one request, not one per row. Deleting thirty notifications individually is
   thirty chances to half-fail and a list that empties in stages in front of the doctor. */
export const deleteAllDoctorNotificationsThunk = createAsyncThunk(
  "notifications/deleteAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.delete("/api/web/notifications");
      if (res.status === 200) return { deleted: res.data?.deleted || 0 };
      return rejectWithValue({ message: res.data?.message || "Could not clear notifications" });
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message || "Could not clear notifications" }
      );
    }
  }
);

export const deleteDoctorNotificationThunk = createAsyncThunk(
  "notifications/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.delete(`/api/web/notifications/${id}`);
      // `wasUnread` comes from the server because the client cannot infer it once the row is
      // gone — without it the unread badge drifts on every delete.
      if (res.status === 200) return { id, wasUnread: !!res.data?.wasUnread };
      return rejectWithValue({ message: res.data?.message || "Could not delete notification" });
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message || "Could not delete notification" }
      );
    }
  }
);

/* ── Doctor KYC / verification (§9, §10, §11.1, §11.2) ───────────────────────────────────────
 * All backed by /api/web/kyc, which is authenticated-doctor only and deliberately NOT
 * verification-gated — these are the calls a doctor makes in order to BECOME verified, so
 * gating them on verification would deadlock the flow (§10.1).
 *
 * Every mutation returns the SAME readiness payload as the GET, so the page never has to
 * re-fetch to learn what its own change unlocked.
 * ---------------------------------------------------------------------------------------- */
export const getKycThunk = createAsyncThunk(
  "kyc/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/web/kyc");
      if (res.status === 200) return res.data;
      return rejectWithValue({ message: res.data?.message || "Could not load your KYC status" });
    } catch (err) {
      /* `httpStatus` is attached explicitly because rejectWithValue normally carries only the
       * response BODY, which has no status code — and a 404 here is meaningfully different from a
       * real failure: it means the API does not have these endpoints (not deployed), which the
       * screen reports as such instead of as "something went wrong". */
      return rejectWithValue({
        httpStatus: err.response?.status || 0,
        ...(err.response?.data || { message: err.message || "Could not load your KYC status" }),
      });
    }
  }
);

export const getRegistrationAuthoritiesThunk = createAsyncThunk(
  "kyc/authorities",
  async (jurisdiction = "IN", { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/web/kyc/authorities?jurisdiction=${encodeURIComponent(jurisdiction)}`);
      // The server sends the "Other (not listed)" escape hatch alongside the registry rather
      // than as part of it. Appended here so the dropdown stays one flat list and older servers
      // that do not send it simply render without the option.
      if (res.status === 200) {
        const list = res.data.authorities || [];
        return res.data.custom ? [...list, res.data.custom] : list;
      }
      return rejectWithValue({ message: res.data?.message || "Could not load councils" });
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message || "Could not load councils" });
    }
  }
);

export const saveKycRegistrationThunk = createAsyncThunk(
  "kyc/saveRegistration",
  async (body, { rejectWithValue }) => {
    try {
      const res = await api.put("/api/web/kyc/registration", body);
      if (res.status === 200) return res.data;
      return rejectWithValue({ message: res.data?.message || "Could not save your registration" });
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message || "Could not save your registration" });
    }
  }
);

export const saveKycPayoutThunk = createAsyncThunk(
  "kyc/savePayout",
  async (body, { rejectWithValue }) => {
    try {
      const res = await api.put("/api/web/kyc/payout", body);
      if (res.status === 200) return res.data;
      return rejectWithValue({ message: res.data?.message || "Could not save your payment details" });
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message || "Could not save your payment details" });
    }
  }
);

export const acceptKycDeclarationThunk = createAsyncThunk(
  "kyc/acceptDeclaration",
  async (key, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/web/kyc/declarations/${key}`, { accepted: true });
      if (res.status === 200) return res.data;
      return rejectWithValue({ message: res.data?.message || "Could not record your declaration" });
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message || "Could not record your declaration" });
    }
  }
);

export const submitKycThunk = createAsyncThunk(
  "kyc/submit",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/web/kyc/submit", {});
      if (res.status === 200) return res.data;
      return rejectWithValue({ message: res.data?.message || "Could not submit your KYC" });
    } catch (err) {
      // A 400 here carries `missing: [...]`, which the page renders as a checklist rather than
      // a generic error — the doctor needs to know WHICH field is outstanding.
      return rejectWithValue(err.response?.data || { message: err.message || "Could not submit your KYC" });
    }
  }
);

/* §8.1 — the doctor's patient-facing consultation fees. Sent in RUPEES (what the doctor types);
 * the server converts to integer paise once. Never send paise from the client — two places
 * converting is two places to disagree. */
export const saveConsultationFeesThunk = createAsyncThunk(
  "kyc/saveFees",
  async (body, { rejectWithValue }) => {
    try {
      const res = await api.put("/api/web/kyc/fees", body);
      if (res.status === 200) return res.data.fees;
      return rejectWithValue({ message: res.data?.message || "Could not save your fees" });
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message || "Could not save your fees" });
    }
  }
);

/* ── §9.3 KYC supporting documents ───────────────────────────────────────────────────────────
 * multipart, so the Content-Type header is left to the browser — setting it manually omits the
 * multipart boundary and the server sees an empty body.
 * -------------------------------------------------------------------------------------------- */
export const uploadKycDocumentThunk = createAsyncThunk(
  "kyc/uploadDocument",
  async ({ file, type }, { rejectWithValue }) => {
    try {
      const form = new FormData();
      form.append("file", file);
      form.append("type", type);
      const res = await api.post("/api/web/kyc/documents", form);
      if (res.status === 201 || res.status === 200) return res.data.documents || [];
      return rejectWithValue({ message: res.data?.message || "Could not upload that document" });
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message || "Could not upload that document" });
    }
  }
);

export const openKycDocumentThunk = createAsyncThunk(
  "kyc/openDocument",
  async (docId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/web/kyc/documents/${docId}/url`);
      if (res.status === 200) return res.data;
      return rejectWithValue({ message: res.data?.message || "Could not open that document" });
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message || "Could not open that document" });
    }
  }
);

export const deleteKycDocumentThunk = createAsyncThunk(
  "kyc/deleteDocument",
  async (docId, { rejectWithValue }) => {
    try {
      const res = await api.delete(`/api/web/kyc/documents/${docId}`);
      if (res.status === 200) return { removedId: docId };
      return rejectWithValue({ message: res.data?.message || "Could not remove that document" });
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message || "Could not remove that document" });
    }
  }
);
